'use strict';

var _monkberry = require('monkberry');

var _monkberry2 = _interopRequireDefault(_monkberry);

var _domDelegate = require('dom-delegate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_monkberry2.default.prototype.on = function (eventType, selector, handler) {
  var _this = this;

  var useCapture = arguments.length <= 3 || arguments[3] === undefined ? undefined : arguments[3];

  if (!this.delegates) {
    this.delegates = [];
    this.nodes.forEach(function (node, i) {
      if (node.nodeType === 8) {
        throw 'Can not use event delegating with non-element nodes on first level.';
      }

      _this.delegates[i] = new _domDelegate.Delegate(node);
    });
  }

  this.delegates.forEach(function (delegate) {
    return delegate.on(eventType, selector, handler, useCapture);
  });
};

_monkberry2.default.prototype.off = function () {
  var eventType = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
  var selector = arguments.length <= 1 || arguments[1] === undefined ? undefined : arguments[1];
  var handler = arguments.length <= 2 || arguments[2] === undefined ? undefined : arguments[2];
  var useCapture = arguments.length <= 3 || arguments[3] === undefined ? undefined : arguments[3];

  this.delegates.forEach(function (delegate) {
    return delegate.off(eventType, selector, handler, useCapture);
  });
};